module.exports = __webpack_public_path__ + "media/src/assets/images/back-7f601405964c6f51bcb1fab05aa2b496.svg";